import React, { useState } from "react";
import { Stack, Box, Typography, Button } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import { useQuery } from "@tanstack/react-query";

import ProfileContent from "../../components/profile/ProfileContent";
import { apiGetUser } from "../../api/users";
import { useNotificationService } from "../../components/notification";
import {
  FacilityDataPropsType,
  FacilityDataPropsTypeDummy,
} from "../../interface/users";
import { useNavigate } from "react-router-dom";
import { PATH_PROFILE } from "../../routes/path";

const Profile = () => {
  const navigate = useNavigate();
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();
  const [facility_info, setFacility_info] = useState<FacilityDataPropsType>(
    FacilityDataPropsTypeDummy,
  );

  const { data, refetch, isLoading } = useQuery({
    queryKey: ["profileInfo"],
    queryFn: async () => {
      const result = await apiGetUser();

      if (result.status === "error" && "details" in result) {
        showNotification(data?.msg ?? "", "error");
        return FacilityDataPropsTypeDummy;
      }
      if (result?.status === 200) {
        setFacility_info(result.data?.data);
      }
      return result?.data?.data || FacilityDataPropsTypeDummy;
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              Profile
            </Typography>
          </Stack>
          <Button
            onClick={() => navigate(PATH_PROFILE.edit)}
            variant="contained"
            sx={{ fontWeight: 700, width: 80 }}
          >
            Edit
          </Button>
        </Box>
      </Header>

      <ProfileContent facility_info={data} loading={isLoading} />
    </>
  );
};

export default Profile;
